import { MouseEvent } from "react";

import { AutocompleteItem } from "@/components/Search/SearchBar/AutocompleteItem/autocompleteItem.container";
import { BaseItemProps } from "@/components/Search/SearchBar/ResultsPanel/resultsPanel.templates";
import { RecentSearchesSourceType } from "@/components/Search/SearchBar/searchBar.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type RecentSearchesItemProps = BaseItemProps<
    RecentSearchesSourceType,
    {
        onRemoveRecentSearchItem: (label: string) => void;
    }
>;

const RecentSearchesItem = ({
    item,
    autocompleteState,
    autocompleteActions,
    onRemoveRecentSearchItem
}: RecentSearchesItemProps) => {
    const { t } = useGranite();

    const handleOnRemoveClick = (event: MouseEvent) => {
        event.stopPropagation();
        onRemoveRecentSearchItem(item.label);
    };

    return (
        <AutocompleteItem<RecentSearchesSourceType>
            query={item.label}
            className={"justify-content-between d-flex rounded"}
            itemId={item.__autocomplete_id}
            autocompleteState={autocompleteState}
            autocompleteActions={autocompleteActions}
            getRedirectUrl={() => item.redirectUrl}
        >
            <div className={"d-flex"}>
                <div>
                    <i className="las la-redo-alt pr-2 mt-1"></i>
                </div>
                {item.label}
            </div>
            <button
                type={"button"}
                className={"recentSearchesItem__delete bg-transparent border-0"}
                onClick={handleOnRemoveClick}
                aria-label={t("accessibility.searchBox.recentSerach")}
            >
                <i className="las la-times"></i>
            </button>
        </AutocompleteItem>
    );
};

export { RecentSearchesItem };
